import { aqiSmoothColor } from '../common/colors';
import { conc2aqi } from '../common/scale';
import { DayYear } from '..//common/isoweek';
import './historical.scss';
var StationHourlyGraph = /** @class */ (function () {
    function StationHourlyGraph(div) {
        this.graph = new HourlyGraph(div);
    }
    StationHourlyGraph.create = function (div) {
        return new StationHourlyGraph(div);
    };
    StationHourlyGraph.prototype.show = function (station, specie, unit, durationInDays) {
        var _this = this;
        if (durationInDays === void 0) { durationInDays = 180; }
        this.graph.reset(specie, unit);
        // console.log('showing graph for ', station.idx)
        var _a = station.historic(specie, durationInDays), obs = _a.obs, closer = _a.closer;
        this.canceller = closer;
        this.subcription = obs.subscribe({
            next: function (x) { return _this.graph.add(x); },
            error: function (err) { return console.error('Observer got an error: ', err); },
            complete: function () { return console.log('Observer got a complete notification'); },
        });
        return this;
    };
    StationHourlyGraph.prototype.cancel = function () {
        if (this.canceller) {
            this.canceller();
        }
    };
    return StationHourlyGraph;
}());
export { StationHourlyGraph };
function getDayName(date) {
    var locale = window.navigator.userLanguage ||
        window.navigator.language ||
        'en';
    return date.toLocaleDateString(locale, { weekday: 'short' });
}
function getMonthName(date) {
    var locale = window.navigator.userLanguage ||
        window.navigator.language ||
        'en';
    return date.toLocaleDateString(locale, { month: 'long' });
}
var HourlyGraph = /** @class */ (function () {
    function HourlyGraph(div) {
        this.div = div;
        this.years = {};
        this.weeks = {};
        this.div = div.c('div', 'historical hourly');
    }
    HourlyGraph.prototype.reset = function (specie, unit) {
        this.specie = specie;
        this.unit = unit;
        this.loading = true;
    };
    HourlyGraph.prototype.add = function (vals) {
        var _this = this;
        vals.forEach(function (_a) {
            var t = _a.t, v = _a.v;
            if (_this.loading) {
                _this.div
                    .c('div', 'header')
                    .html('historical ' + _this.specie + ' data');
            }
            _this.loading = false;
            var aqi = conc2aqi(v, _this.specie, _this.unit);
            var color = aqiSmoothColor(aqi, 'b', _this.specie);
            _this.row(t).set(t.getHours(), color);
        });
    };
    HourlyGraph.prototype.row = function (t) {
        var _a = DayYear(t), day = _a.day, year = _a.year;
        var month = t.getUTCMonth();
        if (!this.weeks[year + month * 12]) {
            var header = this.div
                .c('div', 'week divider')
                .html(getMonthName(t) + ' ' + year);
            this.weeks[year + month * 12] = header;
        }
        if (!this.years[year]) {
            this.years[year] = {};
        }
        if (!this.years[year][day]) {
            var row = new HourlyRow(this.div.c('div', 'row'), 24);
            row.title(getDayName(t) + ' ' + t.getUTCDate());
            this.years[year][day] = row;
        }
        return this.years[year][day];
    };
    return HourlyGraph;
}());
export { HourlyGraph };
var HourlyRow = /** @class */ (function () {
    function HourlyRow(div, nslots) {
        this.div = div;
        this.nslots = nslots;
        this.slots = [];
        this.titlev = div.c('div', 'date');
        for (var i = 0; i < nslots; i++) {
            this.slots.push(div.c('div', ' block hour'));
        }
    }
    HourlyRow.prototype.title = function (s) {
        this.titlev.html(s);
    };
    HourlyRow.prototype.set = function (slot, color) {
        if (slot >= 0 && slot < this.nslots) {
            this.slots[slot].style('background-color', color);
        }
    };
    return HourlyRow;
}());
